import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';
import { SITE } from '@/constants/site';

export default function ProcessingIntroSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            {t('processing.intro.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            {t('processing.intro.title')}
          </h2>
          <div className="mt-5 space-y-4 text-base leading-relaxed text-foreground-600">
            <p>{t('processing.intro.p1')}</p>
            <p>{t('processing.intro.p2')}</p>
          </div>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              {t('nav.cta')}
              <i className="ri-arrow-right-line text-base" />
            </Link>
            <a
              href={SITE.phoneHref}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3.5 text-sm font-semibold text-foreground-900 transition-colors duration-200 hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-phone-line text-base" />
              {SITE.phone}
            </a>
          </div>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-5">
          <div className="grid grid-cols-2 gap-4">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-40 w-full">
                <img
                  src="https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616594_2_250-187.jpg"
                  alt="Blechzuschnitt bei S+N Metall"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
            <div className="mt-8 overflow-hidden rounded-lg border border-background-200">
              <div className="h-40 w-full">
                <img
                  src="https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616614_0_250-187.jpg"
                  alt="Gestanztes Blechbauteil von S+N Metall"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}